import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/_modules/_app/admin/invitations')({
  staticData: {
    title: 'Invitations',
    crumb: 'Invitations',
    permissions: ['invites_view'],
  },
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
